import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
  APP_INITIALIZER,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiInterceptor } from './core/interceptors/api.interceptor';
import { SessionTimeoutService } from './core/services/session-timeout.service';

import { routes } from './app.routes';

/**
 * Factory function to initialize the session timeout service
 * at application startup
 */
export function initializeSessionTimeout(sessionTimeoutService: SessionTimeoutService) {
  return () => {
    sessionTimeoutService.initialize();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    // SessionActivityInterceptor removed - activity monitoring is handled by AuthService
    {
      provide: APP_INITIALIZER,
      useFactory: initializeSessionTimeout,
      deps: [SessionTimeoutService],
      multi: true,
    },
  ],
};
